export const debounce = (func, timeout = 300) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

export const throttle = (func, ms = 50, context = window) => {
  let wait = false
  return (...args) => {
    const later = () => {
      func.apply(context, args)
    }
    if (!wait) {
      later()
      wait = true
      setTimeout(() => {
        wait = false
      }, ms)
    }
  }
}

export const forceTargetOnPDFs = () => {
  const pdfs = document.querySelectorAll('a[href$=".pdf"]')
  if (!pdfs) return
  pdfs.forEach((link) => {
    link.target = '_blank'
  })
}

export const loadScript = (FILE_URL, async = true, type = 'text/javascript') => new Promise((resolve, reject) => {
  try {
    const scriptEle = document.createElement('script')
    scriptEle.type = type
    scriptEle.async = async
    scriptEle.src = FILE_URL

    scriptEle.addEventListener('load', () => {
      resolve({ status: true })
    })

    scriptEle.addEventListener('error', () => {
      reject(new Error(`Failed to load the script ${FILE_URL}`))
    })

    document.body.appendChild(scriptEle)
  } catch (error) {
    reject(error)
  }
})

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms))

let lastViewportHeight
export const getViewportHeight = () => {
  const root = document.documentElement
  const vh = window.innerHeight
  if (vh === lastViewportHeight) return
  lastViewportHeight = vh
  root.style.setProperty('--vh', `${vh}px`)
}

export class DOMAnimations {
  /**
   * Masque un élément avec un effet de repli
   * @param {HTMLElement} element
   * @param {Number} duration
   * @returns {Promise<boolean>}
   */
  static slideUp(element, duration = 500) {
    return new Promise((resolve) => {
      if (window.getComputedStyle(element).display === 'none') resolve()

      element.style.height = `${element.offsetHeight}px`
      element.style.transitionProperty = 'height, margin, padding'
      element.style.transitionDuration = `${duration}ms`
      element.offsetHeight // eslint-disable-line no-unused-expressions
      element.style.overflow = 'hidden'
      element.style.height = 0
      element.style.paddingTop = 0
      element.style.paddingBottom = 0
      element.style.marginTop = 0
      element.style.marginBottom = 0
      window.setTimeout(() => {
        element.style.display = 'none'
        element.style.removeProperty('height')
        element.style.removeProperty('padding-top')
        element.style.removeProperty('padding-bottom')
        element.style.removeProperty('margin-top')
        element.style.removeProperty('margin-bottom')
        element.style.removeProperty('overflow')
        element.style.removeProperty('transition-duration')
        element.style.removeProperty('transition-property')
        resolve(false)
      }, duration)
    })
  }

  /**
   * Affiche un élément avec un effet de dépliement
   * @param {HTMLElement} element
   * @param {Number} duration
   * @returns {Promise<boolean>}
   */
  static slideDown(element, duration = 500, display = 'block') {
    return new Promise((resolve) => {
      element.style.removeProperty('display')
      // let { display } = window.getComputedStyle(element)
      // if (display === 'none') display = 'block'
      element.style.display = display
      const height = element.offsetHeight
      element.style.overflow = 'hidden'
      element.style.height = 0
      element.style.paddingTop = 0
      element.style.paddingBottom = 0
      element.style.marginTop = 0
      element.style.marginBottom = 0
      element.offsetHeight // eslint-disable-line no-unused-expressions
      element.style.transitionProperty = 'height, margin, padding'
      element.style.transitionDuration = `${duration}ms`
      element.style.height = `${height}px`
      element.style.removeProperty('padding-top')
      element.style.removeProperty('padding-bottom')
      element.style.removeProperty('margin-top')
      element.style.removeProperty('margin-bottom')
      window.setTimeout(() => {
        element.style.removeProperty('height')
        element.style.removeProperty('overflow')
        element.style.removeProperty('transition-duration')
        element.style.removeProperty('transition-property')
        resolve(false)
      }, duration)
    })
  }

  /**
   * Affiche ou Masque un élément avec un effet de repli
   * @param {HTMLElement} element
   * @param {Number} duration
   * @returns {Promise<boolean>}
   */
  static slideToggle(element, duration = 500) {
    if (window.getComputedStyle(element).display === 'none') {
      return this.slideDown(element, duration)
    }
    return this.slideUp(element, duration)
  }
}

export const launchIntoFullscreen = (element) => {
  if (element.requestFullscreen) {
    element.requestFullscreen()
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen()
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen()
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen()
  }
}

export const exitFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  }
}

export const iOS = typeof navigator !== 'undefined'
  && (/iPad|iPhone|iPod/.test(navigator.userAgent || '')
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) // iPad iOS 13

export const isSafariDesktop = window.safari !== undefined

export const durationToArray = (time) => {
  const hr = ~~(time / 3600) //eslint-disable-line
  const min = ~~((time % 3600) / 60) //eslint-disable-line
  const sec = +(time % 60).toFixed(0)
  return [hr, min, sec] //eslint-disable-line
}

export const firstFireFoxCheck = () => {
  if (typeof navigator !== "undefined" && navigator.userAgent) {
    if (/firefox/i.test(navigator.userAgent)) {
      document.documentElement.classList.add("is-firefox");
    }
  }
}
